import { Box, Table, TableBody, TableContainer, TableHead, TableHeader, TableRow } from '@ksyos/design-system';
import { useState } from 'react';
import { translateKey } from '../../translate';
import { ListPager } from './ListPager';

interface IGeneralPractitionerSearchResultFormProps {
    children?: JSX.Element | null;
    hidePagination?: boolean;
    itemsPerPage?: number;
    onSearch: (searchName?: string, searchCity?: string, page?: string) => Promise<void>;
    searchCity?: string;
    searchName?: string;
    showNoResults: boolean;
    total: number;
}

export function GeneralPractitionerSearchResultForm(props: IGeneralPractitionerSearchResultFormProps) {
    const [page, setPage] = useState(1);

    if (!props.children || props.showNoResults) {
        return null;
    }

    return (
        <>
            <TableContainer sx={{ mt: 4 }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableHeader>{translateKey('patient.careProvider')}</TableHeader>
                            <TableHeader>{translateKey('patient.careProviderOrganization')}</TableHeader>
                            <TableHeader>{translateKey('common.city')}</TableHeader>
                        </TableRow>
                    </TableHead>
                    <TableBody>{props.children}</TableBody>
                </Table>
            </TableContainer>
            {props.hidePagination || (
                <Box mt={2}>
                    <ListPager
                        itemsPerPage={props.itemsPerPage || 10}
                        onChangePage={handleNavigation}
                        page={page}
                        total={props.total}
                    />
                </Box>
            )}
        </>
    );

    async function handleNavigation(newPage: number) {
        setPage(newPage);
        await props.onSearch(props.searchName, props.searchCity, newPage.toString());
    }
}
